import { useQuery } from 'react-query';

import { getSubProgramPreferenceToggleDate as queryFn } from 'api/endPoints/getSubProgramPreferenceToggleDate';

import { TDefaultOverdueAndUrgentDateThreshold } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/SubProgramPreferences/subProgramPreferences.utils';

export const useQueryOverdueAndUrgentDateThreshold = ({ subProgramId }) => {
    return useQuery<TDefaultOverdueAndUrgentDateThreshold, QueryError>(
        ['useQueryOverdueAndUrgentDateThreshold', subProgramId],
        () => queryFn(subProgramId),
        {
            enabled: Boolean(subProgramId),
        },
    );
};
